<template>
  <v-container>
    <v-card v-if="view === 'signIn'" class="mx-auto opacity-background pa-8" max-width="650">
      <div v-if="!showSignIn" class="_blue--text">{{ $t('countDown') }}: {{ countDown }}</div>
      <v-form ref="form" lazy-validation>
        <v-text-field v-model="email" type="email" :label="$t('email')" :rules="emailRules"></v-text-field>
        <v-text-field v-model="password" type="password" :label="$t('password')" :rules="rules"></v-text-field>
      </v-form>
      <a @click="changeView('forgotPassword')" class="grey--text text--darken-2 text-decoration-underline">{{ $t('forgotPassword') }}？</a>
      &nbsp;&nbsp;
      <a @click="changeView('signUp')" class="grey--text text--darken-2 text-decoration-underline">{{ $t('signUp') }}</a>
      &nbsp;&nbsp;
      <a @click="ssoSignIn()" class="grey--text text--darken-2 text-decoration-underline">{{ "SSO" + $t('signIn') }}</a>
      <VueRecaptcha class="mt-5" ref="recaptcha" @verify="recaptchaVerify" :sitekey="sitekey" :loadRecaptchaScript="true"></VueRecaptcha>
      <!-- <p class="mt-5" v-else>* {{ $t('verifyComplete') }}</p> -->
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="_blue" outlined text @click="$router.go(-1)">{{ $t('cancel') }}</v-btn>
        <v-btn color="_blue" class="white--text" @click="signIn()" :disabled="!isPassCaptcha || !showSignIn">{{ $t('ok') }}</v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="view === 'firstSignIn'" class="mx-auto opacity-background pa-8" max-width="650">
      <v-form ref="form" lazy-validation>
        <v-text-field type="password" :label="$t('newPassword')" v-model="newPassword" :rules="rules"></v-text-field>
        <v-text-field type="password" :label="$t('confirmNewPassword')" v-model="confirmNewPassword" :rules="rules"></v-text-field>
      </v-form>
      <v-checkbox
        v-show="isDeveloper"
        v-model="agreeCooperationTerms"
        @click="showCooperationDialog = true"
        :label="$t('iAgree') + $t('cooperationTerms')"
        readonly
      ></v-checkbox>
      <v-checkbox v-model="agreeServiceTerms" @click="showServiceDialog = true" :label="$t('iAgree') + $t('serviceTerms')" readonly></v-checkbox>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="_blue" class="white--text" @click="firstSignIn()" :disabled="!showFirstSignInBtn">{{ $t('ok') }}</v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="view === 'modifyPassword'" class="mx-auto opacity-background pa-8" max-width="650">
      <div v-if="isForgotPassword" class="_blue--text">{{ $t('countDown') }}: {{ countDown }}</div>
      <v-form ref="form" lazy-validation>
        <v-text-field v-if="isForgotPassword" type="password" :label="$t('verifyCode')" v-model="password" :rules="rules"></v-text-field>
        <v-text-field v-else type="password" :label="$t('password')" v-model="password" :rules="rules"></v-text-field>
        <v-text-field type="password" :label="$t('newPassword')" v-model="newPassword" :rules="rules"></v-text-field>
        <v-text-field type="password" :label="$t('confirmNewPassword')" v-model="confirmNewPassword" :rules="rules"></v-text-field>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="_blue" outlined text @click="$router.go(-1)">{{ $t('cancel') }}</v-btn>
        <v-btn color="_blue" class="white--text" @click="modifyPassword()">{{ $t('ok') }}</v-btn>
      </v-card-actions>
    </v-card>
    <!-- <v-card v-if="view === 'modifyData'" class="mx-auto opacity-background pa-8" max-width="650">
      <v-form ref="form" lazy-validation>
        <v-text-field v-model="userData.name" :label="$t('name')" :rules="rules"></v-text-field>
        <v-text-field v-model="userData.email" :label="$t('email')" disabled></v-text-field>
        <v-text-field v-model="userData.phone" :label="$t('phone')" :rules="rules"></v-text-field>
        <v-text-field v-model="userData.address" :label="$t('address')" :rules="rules"></v-text-field>
        <v-text-field v-model="userData.profession" :label="$t('profession')" :rules="rules"></v-text-field>
        <v-text-field v-model="userData.department" :label="$t('department')" :rules="developerRules"></v-text-field>
        <v-text-field v-model="userData.taxId" :label="$t('taxId')" :rules="developerRules"></v-text-field>
        <v-select :label="$t('industrys')" :items="industryItems" v-model="userData.industrys" :rules="rules"></v-select>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="_blue" outlined text @click="$router.go(-1)">{{ $t('cancel') }}</v-btn>
        <v-btn color="_blue" class="white--text" @click="modifyData()">{{ $t('ok') }}</v-btn>
      </v-card-actions>
    </v-card> -->
    <v-card v-if="view === 'forgotPassword'" class="mx-auto opacity-background pa-8" max-width="650">
      <p class="text-xs-center _blue--text">{{ $t('hintForgotPassword') }}</p>
      <v-form ref="form" lazy-validation>
        <v-text-field v-model="email" type="email" :label="$t('email')" :rules="emailRules"></v-text-field>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="_blue" outlined text @click="view = 'signIn'">{{ $t('cancel') }}</v-btn>
        <v-btn color="_blue" class="white--text" @click="forgotPassword()">{{ $t('ok') }}</v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="view === 'signUp'" class="mx-auto opacity-background pa-8" max-width="650">
      <v-form ref="form" lazy-validation>
        <v-text-field v-model="signUpUser.name" :label="$t('name')" :rules="rules"></v-text-field>
        <v-text-field v-model="signUpUser.email" :label="$t('email')" :rules="emailRules" :disabled="isOauth"></v-text-field>
        <v-text-field v-model="signUpUser.phone" :label="$t('phone')" :rules="rules"></v-text-field>
        <v-text-field v-model="signUpUser.address" :label="$t('address')" :rules="rules"></v-text-field>
        <v-text-field v-model="signUpUser.profession" :label="$t('profession')" :rules="rules"></v-text-field>
        <v-text-field v-model="signUpUser.department" :label="$t('department')" :rules="developerRules"></v-text-field>
        <v-text-field v-model="signUpUser.taxId" :label="$t('taxId')" :rules="developerRules"></v-text-field>
        <v-select :label="$t('industrys')" :items="industryItems" v-model="signUpUser.industrys" :rules="rules"></v-select>
        <template v-if="isOauth">
          <a href="https://hackmd.io/@iMacloud/rJjtTpBI2" target="_blank" rel="noopener">TOTP{{$t('description')}}</a>
          <v-switch v-model="totpStatus" :label="$t('enableTotp')" @change="enableTotp()"></v-switch>
          <v-row v-if="isSetTotp" align="center" class="_grey--text">
            <v-col cols="3"><QrcodeVue :value="qrcodeStr"></QrcodeVue></v-col>
            <v-col cols="7">
              <v-row>
                <div>{{ $t('inputOtp') }}</div>
              </v-row>
              <v-row>
                <div class="position-relative" style="max-width: 300px">
                  <v-otp-input v-model="otpValue" plain></v-otp-input>
                </div>
              </v-row>
            </v-col>
            <v-col cols="2">
              <v-btn @click="verifyTotp()">{{ $t('verify') }}</v-btn>
            </v-col>
          </v-row>
        </template>
        <v-checkbox input-value="true" :label="$t('iAmUser')" readonly></v-checkbox>
        <v-checkbox v-model="isSignUpDeveloper" :label="$t('iAmDeveloper')"></v-checkbox>
        <v-checkbox
          v-show="isSignUpDeveloper"
          v-model="agreeCooperationTerms"
          @click="showCooperationDialog = true"
          :label="$t('iAgree') + $t('cooperationTerms')"
          readonly
        ></v-checkbox>
        <v-checkbox v-model="agreeServiceTerms" @click="showServiceDialog = true" :label="$t('iAgree') + $t('serviceTerms')" readonly></v-checkbox>
      </v-form>
      <VueRecaptcha
        class="mt-5"
        ref="recaptcha"
        @verify="recaptchaVerify"
        @expired="recaptchaExpired"
        :sitekey="sitekey"
        :loadRecaptchaScript="true"
      ></VueRecaptcha>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-show="!isOauth" color="_blue" outlined text @click="changeView('signIn')">{{ $t('cancel') }}</v-btn>
        <v-btn color="_blue" class="white--text" @click="signUp()" :disabled="!showSignUpBtn">{{ $t('ok') }}</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="showCooperationDialog" persistent max-width="760">
      <TermsCooperation
        @close="showCooperationDialog = agreeCooperationTerms = false"
        @agree="
          showCooperationDialog = false;
          agreeCooperationTerms = true;
        "
      />
    </v-dialog>
    <v-dialog v-model="showServiceDialog" persistent max-width="760">
      <TermsService
        @close="showServiceDialog = agreeServiceTerms = false"
        @agree="
          showServiceDialog = false;
          agreeServiceTerms = true;
        "
      />
    </v-dialog>
    <v-dialog v-model="showSuccessDialog" persistent max-width="300" transition="dialog-top-transition">
      <v-card class="mx-auto green darken-1 white--text">
        <v-card-title>{{ $t('hintSignUpSuccess') }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="_blue white--text" @click="showSuccessDialog = false">{{ $t('ok') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import VueRecaptcha from 'vue-recaptcha';
import QrcodeVue from 'qrcode.vue';
import TermsService from '../components/TermsService.vue';
import TermsCooperation from '../components/TermsCooperation.vue';
import User from '../store/user';

export default {
  name: 'account',
  components: {
    VueRecaptcha,
    TermsService,
    TermsCooperation,
    QrcodeVue,
  },
  props: { form: { type: String, default: 'signIn' }, redirectUrl: { type: String, default: '' } },
  data: () => ({
    view: '',
    email: '',
    password: '',
    showSignIn: true,
    signUpUser: { industrys: 'All' },
    isPassCaptcha: false,
    isSignUpDeveloper: false,
    isForgotPassword: false,
    showServiceDialog: false,
    showCooperationDialog: false,
    showSuccessDialog: false,
    agreeServiceTerms: false,
    agreeCooperationTerms: false,
    newPassword: '',
    confirmNewPassword: '',
    countDown: 60,
    sitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
    totpStatus: false,
    isSetTotp: false,
    qrcodeStr: '',
    otpValue: '',
  }),
  computed: {
    ...mapState('authenticate', ['isSignIn', 'user', 'userAttribute']),
    ...mapGetters('dbTable', ['industryList', 'permissionId', 'policyByUserType']),
    rules() {
      return [(v) => !!v || this.$t('require')];
    },
    emailRules() {
      return [(v) => /[a-zA-Z0-9._%-]+@.+\..+/.test(v) || this.$t('invalid')];
    },
    developerRules() {
      return [(v) => this.isSignUpDeveloper || !!v || this.$t('require')];
    },
    showSignUpBtn() {
      return this.isPassCaptcha && this.agreeServiceTerms && (!this.isSignUpDeveloper || this.agreeCooperationTerms);
    },
    showFirstSignInBtn() {
      return this.agreeServiceTerms && (!this.isDeveloper || this.agreeCooperationTerms);
    },
    isDeveloper() {
      if (!this.isSignIn) return false;
      if (!Object.keys(this.userAttribute).length) return false;
      return Object.keys(this.userAttribute.policy).findIndex((x) => x === this.permissionId('launch')) !== -1;
    },
    industryItems() {
      if (!this.industryList) return [];
      const ary = this.industryList.map((x) => ({ text: x.name, value: x.id }));
      ary.unshift({ text: 'All', value: 'All' });
      return ary;
    },
    userData() {
      return { ...this.userAttribute };
    },
    isOauth() {
      // return window.sessionStorage.getItem('isOauthTest') === 'true';// CHERRY_TEST
      return process.env.VUE_APP_SSO === 'oauth2';// CHERRY_TEST
    },
  },
  mounted() {
    if (!this.isSignIn) {
      if (this.isOauth) {
        this.$router.push({ name: 'main' });
      } else this.view = 'signIn';
    } else this.view = this.$route.name;
    if (this.isOauth && this.user) this.signUpUser.email = this.user.email;
    if (!this.isOauth) return;
    this.$store.commit('loading/start', { text: 'working' });
    this.$store
      .dispatch('authenticate/oauthToken', { refreshToken: window.localStorage.getItem('oauthRefreshToken') })
      .then((result) => {
        this.$store.commit('authenticate/setUserAccessToken', result.accessToken);
        this.$store
          .dispatch('authenticate/totpStatus')
          .then((status) => {
            this.totpStatus = status;
            console.log('totp status', this.totpStatus);
            this.$store.commit('loading/stop');
          })
          .catch(() => {
            this.totpStatus = false;
            this.$store.commit('loading/stop');
          });
      })
      .catch(() => {
        window.sessionStorage.setItem('isOauthTest', false);// CHERRY_TEST
        this.$store.commit('loading/stop');
        this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('errLoginExpired')] });
        window.localStorage.removeItem('oauthRefreshToken');
        window.localStorage.removeItem('oauthCode');
      });
  },
  methods: {
    // CHERRY_TEST->
    ssoSignIn() {
      const localUrl = `${window.location.origin}${window.location.pathname}`;
      console.log(localUrl);
      this.$store.dispatch('authenticate/oauthSignInUrl', { redirectUrl: localUrl }).then((res) => {
        window.sessionStorage.setItem('isOauthTest', true);
        // console.log(res);
        window.location.href = res;
      });
    },
    // <-CHERRY_TEST
    recaptchaVerify() {
      this.isPassCaptcha = true;
    },
    recaptchaExpired() {
      this.isPassCaptcha = false;
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset(); // Direct call reset method
    },
    changeView(view) {
      this.view = view;
      if (this.$refs.form) this.$refs.form.reset();
    },
    signIn() {
      if (!this.$refs.form.validate()) return;
      window.sessionStorage.setItem('isOauthTest', false);// CHERRY_TEST
      this.$store.commit('loading/start', { text: 'working' });
      User.read(this.email).then((data) => {
        if (data === undefined) {
          this.$store.commit('loading/stop');
          this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('errNotAuthorized')] });
          return;
        }
        this.$store
          .dispatch('authenticate/signIn', { email: this.email.trim(), password: this.password })
          .then((result) => {
            this.$store.commit('authenticate/setUserAttribute', data);
            this.email = '';
            this.password = '';
            this.resetRecaptcha();
            this.$store.commit('loading/stop');
            if (result.challengeName === 'NEW_PASSWORD_REQUIRED') {
              this.$store.commit('notify/set', { type: 'success', msg: [this.$t('signIn'), ' ', this.$t('success')] });
              this.changeView('firstSignIn');
            } else if (result.challengeName && result.challengeName !== '') {
              this.$store.commit('notify/set', { type: 'alarm', msg: [`Not ready to implement this challenge ${result.challengeName}`] });
            } else {
              this.$store.commit('notify/set', { type: 'success', msg: [this.$t('signIn'), ' ', this.$t('success')] });
              // [cherry] migrate user pool ===
              const items = { ...data };
              if (result.attributes.sub !== items.cognitoId) {
                User.update({ email: items.email, cognitoId: result.attributes.sub });
                items.cognitoId = result.attributes.sub;
                this.$store.commit('authenticate/setUserAttribute', items);
              }
              // ================================
              if (!this.userAttribute.changePwTime || (new Date().getTime() - this.userAttribute.changePwTime) > (180 * 24 * 60 * 60 * 1000)) {
                this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('hintPwMaxAge')] });
              }
              this.$router.push({ name: 'main' });
            }
          })
          .catch((error) => {
            let message = '';
            switch (error.message) {
              case 'User does not exist.': // UserNotFoundException
                message = this.$t('errUserNotFound');
                break;
              case 'Incorrect username or password.': // NotAuthorizedException
                message = this.$t('errNotAuthorized');
                break;
              case 'Password attempts exceeded': {
                this.showSignIn = false;
                message = this.$t('errPasswordAttemptsExceeded');
                const clock = setInterval(() => {
                  this.countDown -= 1;
                  if (this.countDown < 0) {
                    clearInterval(clock);
                    this.resetRecaptcha();
                    this.isPassCaptcha = false;
                    this.showSignIn = true;
                  }
                }, 1000);
                break;
              }
              case 'Temporary password has expired and must be reset by an administrator.':
                message = this.$t('errTemporaryPasswordExpired');
                break;
              case 'UserNotConfirmedException':
              case 'User is disabled.':
                message = this.$t('errNotConfirmed');
                break;
              case "Failed to execute 'setItem' on 'Storage': Setting the value of 'user' exceeded the quota.":
                message = this.$t('errLocalStorageFull');
                break;
              default:
                message = error.message;
                break;
            }
            this.$store.commit('loading/stop');
            this.$store.commit('notify/set', { type: 'alarm', msg: [message] });
          });
      });
    },
    modifyPassword() {
      if (!this.$refs.form.validate()) return;
      if (this.userData.changePwTime && (new Date().getTime() - this.userData.changePwTime) < (24 * 60 * 60 * 1000)) {
        this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('hintPwMinAge')] });
        return;
      }
      if (this.newPassword !== this.confirmNewPassword) {
        this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('errPasswordNotMatch')] });
        return;
      }
      const reg = /^(?=.*[a-zA-Z])(?=.*\d).{8,16}$/;
      if (!reg.test(this.newPassword)) {
        this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('errPasswordTooWeak')] });
        return;
      }
      this.$store.commit('loading/start', { text: 'working' });
      this.userData.changePwTime = new Date().getTime();
      User.update(this.userData);
      this.$store.commit('authenticate/setUserAttribute', this.userData);
      if (this.isForgotPassword) {
        this.$store
          .dispatch('authenticate/forgotPasswordSubmit', { email: this.email, code: this.password, newPassword: this.newPassword })
          .then(() => {
            this.$store.commit('loading/stop');
            this.$store.commit('notify/set', { type: 'success', msg: [this.$t('modify'), ' ', this.$t('success')] });
            this.changeView('signIn');
            this.password = '';
            this.newPassword = '';
            this.confirmNewPassword = '';
            this.isForgotPassword = false;
          })
          .catch((error) => {
            let message = '';
            switch (error.message) {
              case 'Invalid verification code provided, please try again.':
                message = this.$t('errVerifyCode');
                break;
              default:
                message = error.message;
                break;
            }
            this.$store.commit('loading/stop');
            this.$store.commit('notify/set', { type: 'alarm', msg: [message] });
          });
      } else if (this.isOauth) {
        this.$store
          .dispatch('authenticate/oauthChangePassword', { password: this.password, newPassword: this.newPassword })
          .then((result) => {
            this.$store.commit('loading/stop');
            if (result.status === 'success') {
              this.$store.commit('notify/set', { type: 'success', msg: [this.$t('modify'), ' ', this.$t('success')] });
              this.$router.push({ name: 'main' });
              this.password = '';
              this.newPassword = '';
              this.confirmNewPassword = '';
            } else {
              let message = '';
              switch (result.error.message) {
                case 'Incorrect username or password.': // NotAuthorizedException
                  message = this.$t('errNotAuthorized');
                  break;
                default:
                  message = result.error.message;
                  break;
              }
              this.$store.commit('notify/set', { type: 'alarm', msg: [message] });
            }
          })
          .catch((error) => {
            this.$store.commit('loading/stop');
            this.$store.commit('notify/set', { type: 'alarm', msg: [error] });
          });
      } else {
        this.$store
          .dispatch('authenticate/changePassword', { password: this.password, newPassword: this.newPassword })
          .then(() => {
            this.$store.commit('loading/stop');
            this.$store.commit('notify/set', { type: 'success', msg: [this.$t('modify'), ' ', this.$t('success')] });
            this.$router.push({ name: 'main' });
            this.password = '';
            this.newPassword = '';
            this.confirmNewPassword = '';
          })
          .catch((error) => {
            let message = '';
            switch (error.message) {
              case 'Incorrect username or password.': // NotAuthorizedException
                message = this.$t('errNotAuthorized');
                break;
              default:
                message = error.message;
                break;
            }
            this.$store.commit('loading/stop');
            this.$store.commit('notify/set', { type: 'alarm', msg: [message] });
          });
      }
    },
    // modifyData() {
    //   if (!this.$refs.form.validate()) return;
    //   User.update(this.userData)
    //     .then(() => {
    //       this.$store.commit('authenticate/setUserAttribute', this.userData);
    //       this.$store.commit('notify/set', { type: 'success', msg: [this.$t('modify'), ' ', this.$t('success')] });
    //       this.$router.push({ name: 'main' });
    //     })
    //     .catch((error) => {
    //       this.$store.commit('notify/set', { type: 'alarm', msg: [error] });
    //     });
    // },
    forgotPassword() {
      if (!this.$refs.form.validate()) return;
      User.read(this.email).then((data) => {
        if (data === undefined) {
          this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('errUserNotFound')] });
          return;
        }
        if (data.group !== 'pass') {
          this.$store.commit('notify/set', { type: 'success', msg: [this.$t('hintSignUpSuccess')] });
          return;
        }
        this.$store.commit('loading/start', { text: 'working' });
        this.$store
          .dispatch('authenticate/forgotPassword', { email: this.email.trim() })
          .then(() => {
            this.$store.commit('loading/stop');
            this.isForgotPassword = true;
            this.countDown = 300;
            this.view = 'modifyPassword';
            const clock = setInterval(() => {
              this.countDown -= 1;
              if (this.countDown < 0) {
                clearInterval(clock);
                this.changeView('signIn');
              }
            }, 1000);
          })
          .catch((error) => {
            switch (error.message) {
              case 'User password cannot be reset in the current state.':
                this.$store
                  .dispatch('authenticate/resendVerifyCode', { email: this.email.trim() })
                  .then(() => {
                    this.$store.commit('loading/stop');
                    this.$store.commit('notify/set', { type: 'success', msg: [this.$t('hintForgotPassword')] });
                    this.changeView('signIn');
                  })
                  .catch((err) => this.$store.commit('notify/set', { type: 'alarm', msg: [err] }));
                return;
              default:
                break;
            }
            this.$store.commit('loading/stop');
            this.$store.commit('notify/set', { type: 'alarm', msg: [error] });
          });
      });
    },
    oauthSignUp() {
      if (!this.$refs.form.validate()) return;
      this.signUpUser.cognitoId = this.user.cognitoId;
      this.signUpUser.policy = this.policyByUserType(this.isSignUpDeveloper ? '2' : '1').policy;
      this.signUpUser.oauthSignUp = true;
      this.$store.commit('loading/start', { text: 'working' });
      User.create(this.signUpUser)
        .then(() => {
          User.read(this.signUpUser.email).then((data) => {
            this.$store.commit('loading/stop');
            this.$store.commit('authenticate/setUserAttribute', data);
            this.$store.dispatch('authenticate/oauthSignInUrl', { redirectUrl: this.redirectUrl }).then((url) => {
              window.location.href = url;
            });
          });
        })
        .catch((error) => {
          this.$store.commit('loading/stop');
          this.$store.commit('notify/set', { type: 'alarm', msg: [error.message] });
        });
    },
    signUp() {
      if (this.isOauth) {
        this.oauthSignUp();
        return;
      }
      if (!this.$refs.form.validate()) return;
      this.signUpUser.email = this.signUpUser.email.trim();
      this.signUpUser.policy = this.policyByUserType(this.isSignUpDeveloper ? '2' : '1').policy;
      this.$store.commit('loading/start', { text: 'working' });
      User.create(this.signUpUser)
        .then(() => {
          this.$store.commit('loading/stop');
          // this.$store.commit('notify/set', { type: 'success', msg: [this.$t('hintSignUpSuccess')] });
          this.signUpUser = { industrys: 'All' };
          this.isPassCaptcha = false;
          this.isSignUpDeveloper = false;
          this.agreeServiceTerms = false;
          this.agreeCooperationTerms = false;
          this.resetRecaptcha();
          this.changeView('signIn');
          this.showSuccessDialog = true;
        })
        .catch((error) => {
          this.$store.commit('loading/stop');
          let message = '';
          switch (error.message) {
            case 'An account with the given email already exists.':
              message = this.$t('errEmailExist');
              break;
            case "Failed to execute 'setItem' on 'Storage': Setting the value of 'user' exceeded the quota.":
              message = this.$t('errLocalStorageFull');
              break;
            default:
              message = error.message;
              break;
          }
          this.$store.commit('notify/set', { type: 'alarm', msg: [message] });
        });
    },
    firstSignIn() {
      if (!this.$refs.form.validate()) return;
      if (this.newPassword !== this.confirmNewPassword) {
        this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('errPasswordNotMatch')] });
        return;
      }
      const reg = /^(?=.*[a-zA-Z])(?=.*\d).{8,16}$/;
      if (!reg.test(this.newPassword)) {
        this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('errPasswordTooWeak')] });
        return;
      }
      this.$store.commit('loading/start', { text: 'working' });
      this.userData.changePwTime = new Date().getTime();
      User.update(this.userData);
      this.$store.commit('authenticate/setUserAttribute', this.userData);
      this.$store
        .dispatch('authenticate/changeNewPassword', { newPassword: this.newPassword })
        .then(() => {
          this.$store.commit('loading/stop');
          this.$store.commit('notify/set', { type: 'success', msg: [this.$t('modify'), ' ', this.$t('success')] });
          this.agreeServiceTerms = false;
          this.agreeCooperationTerms = false;
          this.changeView('signIn');
        })
        .catch((error) => {
          let message = '';
          switch (error.message) {
            case "Failed to execute 'setItem' on 'Storage': Setting the value of 'user' exceeded the quota.":
              message = this.$t('errLocalStorageFull');
              break;
            default:
              message = error.message;
              break;
          }
          this.$store.commit('loading/stop');
          this.$store.commit('notify/set', { type: 'alarm', msg: [message] });
        });
    },
    isTotp() {
      this.$store
        .dispatch('authenticate/totpStatus')
        .then((result) => {
          this.totpStatus = result;
          console.log('totp status', this.totpStatus);
        })
        .catch(() => {
          this.totpStatus = false;
        });
    },
    enableTotp() {
      this.$store.commit('loading/start', { text: 'working' });
      this.$store
        .dispatch('authenticate/totpEnable', { enable: this.totpStatus })
        .then((result) => {
          this.isSetTotp = this.totpStatus;
          this.$store.commit('loading/stop');
          console.log(result);
          if (this.totpStatus) {
            const user = encodeURIComponent(this.userAttribute.email);
            this.qrcodeStr = `otpauth://totp/${encodeURIComponent('iMacloud OTP')}:${user}?secret=${result}&issuer=ITRI`;
          } else {
            this.qrcodeStr = '';
            this.$store.commit('notify/set', { type: 'success', msg: [this.$t('close'), ' ', this.$t('success')] });
          }
        })
        .catch(() => {
          this.totpStatus = false;
          this.isSetTotp = false;
          this.qrcodeStr = '';
          this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('errLoginExpired')] });
          this.$store.commit('loading/stop');
        });
    },
    verifyTotp() {
      if (this.otpValue === '') {
        this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('errVerifyCode')] });
        return;
      }
      this.$store
        .dispatch('authenticate/totpVerify', { code: this.otpValue })
        .then((result) => {
          this.otpValue = '';
          if (result.status === 'fail') {
            this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('errVerifyCode')] });
          } else {
            this.$store.commit('notify/set', { type: 'success', msg: [this.$t('verify'), ' ', this.$t('success')] });
            this.isSetTotp = false;
            this.isTotp();
          }
        })
        .catch((err) => {
          console.log(err);
          this.otpValue = '';
          this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('errVerifyCode')] });
        });
    },
  },
};
</script>

<style scoped>
.opacity-background {
  background-color: rgba(255, 255, 255, 0.75) !important;
}
</style>
